<template>
  <footer class="footer">
      <p :class="[canClick?'canclick':'']" @click="btnClick">{{text}}</p>
  </footer>
</template>

<script>
export default {
  name: 'commonFooter',
  props: {
    text:{
      type:String,
      default:'下一步'
    },
    canClick:{
      type:Boolean,
      default:true
    }
  },
  methods: {
    btnClick(){
      if(!this.canClick){
        return;
      }
      this.$emit("btnClick")
    }
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/common.less";
.footer {
  position: fixed;
  bottom:0;left:0;right:0;
  z-index:333;
  background:#fff;
  height:108px;
  width:100%;
  p{
    display: block;
    margin:16px 28px;
    height:76px;
    line-height:76px;
    text-align:center;
    background:#dadada;
    border-radius: 4px;
    color:#fff;
    font-size:32px;
    &.canclick{
      background:#1740DA;
    }
  }
}
</style>
